// Copyright (C) 2021 TANNER AG

import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";

const Tracker = ({ history }) => {
    useEffect(() => {
        history.listen(() => {
            if (process.env.REACT_APP_STAGE === "PUBLISHED") {
                window.et_eC_Wrapper && window.et_eC_Wrapper({ et_et: "iVbqWx" });
            }
        });
    }, []);
    return <div />;
};

export default withRouter(Tracker);



// WEBPACK FOOTER //
// ./src/components/Tracker.js